import { baseEnvironment } from './base-environment';
import type { Environment } from './environment-type';

export const environment: Environment = {
  ...baseEnvironment,
  turnstileSiteKey: 'KHWEBAPP_TURNSTILESITEKEY',
  AngularJsBaseUrl: 'KHWEBAPP_APPJSURL',
  coreApiUrl: 'KHWEBAPP_COREURL',
  mmsUrl: 'KHWEBAPP_MMSURL',
  featureFlags: {
    ...baseEnvironment.featureFlags
  },
  clientVersion: 'KHWEBAPP_CLIENT_VERSION'
};
